export default __webpack_public_path__ + "static/media/ANSIA_ICONA .38c94617.svg";